// back compat

import "./joinedPhysicsEngineComponent";
import "./v1/physicsEngineComponent";
import "./v2/physicsEngineComponent";
